import common from "../../../utils/common";
import c from "../../../utils/constants";

class userWalletTransactionsController {
  constructor() {
    "ngInject"
    
  }
  
  $onInit() {
    
    this.gridOptions = {
      dataSource: this.walletTransactions,
      sortable: true,
      pageable: false,
      resizable: true,
      noRecords: {
        template: "No Transactions."
      },
      columns: [
        { field: "creationDate", title: "Date", filterable: false, width: "4rem", template: `#= kendo.toString(new Date(creationDate), 'dd-MM-yyyy') #` },
        { field: "transactionType", title: "Type", filterable: false, width: "4rem", template: (dataItem) => `${this._getTransactionType(dataItem.transactionType)}` },
        { field: "total", title: "Total", filterable: false, width: "4rem", template: `#= '$' + (total/100).toFixed(2) #` },
        { field: "transactionReason", title: "Reason", filterable: false, width: "8rem", template: (dataItem) => `${this._getTransactionReason(dataItem.transactionReason)}` },
        { field: "transactionOwner", title: "Owner", filterable: false, width: "4rem", template: (dataItem) => `${this._getTransactionOwner(dataItem.transactionOwner)}` },
      ]
    }
  }
  
  _getTransactionType(type) {
    switch(type) {
      case c.walletTransactionType.ADD:
        return "Add";
      case c.walletTransactionType.DEDUCT:
        return "Deduct";
      case c.walletTransactionType.REFUND:
        return "Refund";
    }
  }
  
  _getTransactionReason(reason) {
    switch(reason) {
      case c.walletTransactionReason.ACCOUNT_CREATED:
        return "Account Created";
      case c.walletTransactionReason.JOB_POSTED:
        return "Job Posted";  
      case c.walletTransactionReason.JOB_CANCELLED:
        return "Job Cancelled";
      case c.walletTransactionReason.ADMIN_ACTION:
        return "Admin Action";
      case c.walletTransactionReason.SINGLE_ONE_OFF_JOB_PURCHASE:
        return "Single One-off Job Purchase";
      case c.walletTransactionReason.SINGLE_RECURRING_JOB_PURCHASE:
        return "Single Recurring Job Purchase";
      case c.walletTransactionReason.WALLET_PAYMENT:
        return "Wallet Payment";
      case c.walletTransactionReason.JOB_CANCELLED_BY_HELPER:
        return "Job Cancelled by Helper";
      
    }
  }
  
  _getTransactionOwner(owner) {
    switch(owner) {
      case c.walletTransactionOwner.UNSPECIFIED:
        return "Unspecified";
      case c.walletTransactionOwner.USER:
        return "User";
      case c.walletTransactionOwner.SYSTEM:
        return "System";
      case c.walletTransactionOwner.ADMIN:
        return "Admin";
    }
  }
  
}

export default userWalletTransactionsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-wallet-transactions/user-wallet-transactions.controller.js
 **/